import { TMovement } from '../interfaces/disbursement';

export const descriptionMatchers = (movement: TMovement) => [
  {
    matcher: movement.clientCode?.includes('debit-cession-value-funding'),
    description: `Pagamento de Cessão - Solicitação ${
      movement.disbursementSequentialId || '-'
    }`,
  },
  {
    matcher: movement.clientCode?.includes('rollback-cession-value-issuer'),
    description: `Devolução de Cessão - Solicitação ${
      movement.disbursementSequentialId || '-'
    }`,
  },
  {
    matcher: movement.clientCode?.includes('debit-disbursement-amount-issuer'),
    description: `Desembolso - Solicitação ${
      movement.disbursementSequentialId || '-'
    }`,
  },
  {
    matcher: movement.clientCode?.includes(
      'rollback-disbursement-amount-borrower',
    ),
    description: `Devolução Solicitação ${
      movement.disbursementSequentialId || '-'
    }`,
  },
  {
    matcher: movement.clientCode?.includes('credit-cession-value-issuer'),
    description: `Recebimento de Cessão - Solicitação ${
      movement.disbursementSequentialId || '-'
    }`,
  },
  {
    matcher: movement.clientCode?.includes('rollback-cession-value-funding'),
    description: `Estorno de Cessão - Solicitação ${
      movement.disbursementSequentialId || '-'
    }`,
  },
  {
    matcher: movement.clientCode?.includes(
      'credit-disbursement-amount-borrower',
    ),
    description: `Recebimento de Desembolso - Solicitação ${
      movement.disbursementSequentialId || '-'
    }`,
  },
  {
    matcher: movement.clientCode?.includes(
      'rollback-disbursement-amount-issuer',
    ),
    description: `Estorno Desembolso - Solicitação ${
      movement.disbursementSequentialId || '-'
    }`,
  },
  {
    matcher: movement.movementType === 'TEDTRANSFEROUT',
    description: `Transferência TED - ${movement.creditPartyName}`,
  },
  {
    matcher: movement.movementType === 'TEDTRANSFEROUT',
    description: `Transferência TED - ${movement.creditPartyName}`,
  },
  {
    matcher: movement.movementType === 'TEDTRANSFERIN',
    description: `Recebimento TED - ${movement.debitPartyName}`,
  },
  {
    matcher: movement.movementType === 'PIXREVERSALIN',
    description: `${movement.description}`,
  },
  {
    matcher: movement.movementType === 'PIXREVERSALOUT',
    description: `Estorno PIX - ${movement.originalEndToEndId}`,
  },
  {
    matcher: movement.movementType === 'PIXPAYMENTOUT',
    description: `Transferência Pix - ${movement.creditPartyName}`,
  },
  {
    matcher: movement.movementType === 'PIXPAYMENTIN',
    description: `Recebimento Pix - ${movement.debitPartyName}`,
  },
];

export const getReportDescription = (movement: TMovement): string => {
  const match = descriptionMatchers(movement).find(
    (matcher) => matcher.matcher,
  );
  return match ? match.description : movement.description || '';
};
